import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=b930029e&scoped=true&lang=html&"
import script from "./PieChart.vue?vue&type=script&lang=js&"
export * from "./PieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b930029e",
  null
  
)

export default component.exports